/*eslint-disable*/

import {
  computed, watch, ref,
} from '@vue/composition-api'
import { concat, assign } from 'lodash'
import useRequest from '@/compositions/useRequest'
import { camel } from '@/utils/ws'
import Message from './components/Message'
import NewMessageForm from './components/NewMessageForm'
import useMessages from '@/compositions/useMessages'
import { capitalizedWord } from '@/utils/capitalizedWord'

export default {
  components: {
    NewMessageForm, Message,
  },
  props: {
    messagesList: {
      type: Array,
      default: () => [],
    },
    id: Number,
    type: String,
    heightDiff: String,
  },
  channels: {
    ChatChannel: {
      connected() {},
      received(data) {
        this.updateList(camel(data.message))
      },
    },
  },


  setup(props, context) {
    const { root } = context
    const { $store } = root

    const messagesRaw = ref(props.messagesList)
    const messageReaders = ref([])
    const userId = computed(() => $store.getters['auth/userId'])

    // order messages
    const { makeRequest, loading } = useRequest({
      request: () => {
        switch (props.type) {
          case 'order':
            return $store.dispatch('messages/getMessages', { orderId: props.id })
          case 'tracker':
            return $store.dispatch('tracker/fetchMessages', { trackId: props.id })
          default:
            return $store.dispatch('messages/getMessages', { orderId: props.id })
        }
      },
      context,
    })

    const sentMassegeRequest = useRequest({
      context,
      successMessage: 'Сообщение отправлено!',
      request: data => $store.dispatch('messages/postMessage', data),
    })

    const fetchMessages = async () => {
      const data = await makeRequest({ id: props.id })
      messagesRaw.value = data.messages
      messageReaders.value = data.messageReaders
    }

    watch(() => props.id, async () => {
      if (props.id) {
        await fetchMessages()
      } else {
        messagesRaw.value = []
      }
    }, { immediate: true, deep: true })

    // messages

    const { messages } = useMessages(messagesRaw, userId, messageReaders)

    // stylesComputed
    const styleHeight = computed(() => ({
      height: `calc(100vh - ${props.heightDiff})`,
      minHeight: '40rem',
    }))


    // intersection observe
    const messageContainer = ref(null)
    const messageItem = ref([])
    const lastMessageAnchor = ref(null)
    let observer


    const { makeRequest: setMessagesRead } = useRequest({
      request: (data) => {
        switch (props.type) {
          case 'order':
            return $store.dispatch('messages/postMessagesRead', { orderId: props.id, messageId: data.messageId })
          case 'tracker':
            return $store.dispatch('tracker/markMessagesRead', { trackId: props.id, messagesIds: data.messagesIds })
          default:
            return $store.dispatch('messages/postMessagesRead', { orderId: props.id, messageId: data.messageId })
        }
      },
      context,
    })

    const sendRead = ((messageId) => {
      setMessagesRead({messageId})
    })

    watch(() => messageItem.value, () => {
      if (lastMessageAnchor.value) lastMessageAnchor.value.scrollIntoView({ block: 'end' })
      if (observer) {
        const observable = concat([], messageItem.value)
        observable.forEach((item) => {
          observer.observe(item.$el)
        })
      }
    })

    // ws
    const sendLoading = ref(false)

    const sendMessage = (messData) => {
      const data = {
        messagebleType: capitalizedWord(props.type),
        messagebleId: props.id,
        ...messData,
      }
      sentMassegeRequest.makeRequest(data)
      sendLoading.value = true
    }

    const updateList = (data) => {
      const existingMessage = messagesRaw.value.find(item => item.id === data.id)
      if (existingMessage) {
        console.log('existingMessage', existingMessage)
        assign(existingMessage, data)
      } else {
        console.log('not exist data', data)
        messagesRaw.value.push(data)
      }
      sendLoading.value = false
    }

    const hanldeInView = (item) => {
      if (!item.yours && !item.isRead) {
        sendRead(item.id)
      }
    }

    watch(() => props.id, () => {
      root.$cable.unsubscribe('ChatChannel')
      root.$cable.subscribe({
        channel: 'ChatChannel',
        messageble_id: props.id,
        messageble_type: capitalizedWord(props.type),
      })
    }, { immediate: true })

    return {
      loading,
      messages,
      styleHeight,
      messageContainer,
      messageItem,
      lastMessageAnchor,
      fetchMessages,
      sendMessage,
      updateList,
      hanldeInView,
      sendLoading,
    }
  },
}
